import { render, staticRenderFns } from "./ProcedureStages.vue?vue&type=template&id=b40c1bb0"
import script from "./ProcedureStages.vue?vue&type=script&lang=js"
export * from "./ProcedureStages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports